import React, { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import dollar from "jquery";
import { useEffect } from "react";
import {  isEqual } from "lodash";
import { SET_USER_TASK_CHART_SELECTED_INDEX,
        SET_USER_TASK_LIST_DATAGRID_FILTER,
        SET_USER_TASK_CHART_BUTTON_VALUE,
        SET_USER_TASK_CHART_ICON_VALUE,
        SET_TASK_HQ_COMPLETED_AND_CANCELED_TAB_DATA,} from "./reducers/user-task-list-reducer";
import Chart, { CommonSeriesSettings, Series, SeriesTemplate, Size, Title, Tooltip } from "devextreme-react/chart";
import MdaePieChart from "../common_widgets/pie-chart"
import MdaeChart from "../common_widgets/chart"
import {Legend } from "devextreme-react/pie-chart";
import { getFutureDateFromDays, getPastDateFromDays } from "../../utils/dateUtils";
import MdaeButton from "../common_widgets/button";
import { setIsGridSettingCalled } from "./component";
import { getUserPreference, setUserPreference } from "../../utils/commom-utils";
import { TaskFilter, getLocalStorageValueOrDefault } from "../../pages/my-tasks/component";
import { defaultCompletedAndCanceledTabData } from "../../pages/my-tasks/reducers/my-tasks-page-reducer";
export const USER_TASK_STATUS_TYPE = {
    NEW: "New",
    IN_PROGRESS: "In-Progress",
  };
  export const DAYS_RANGE={
    SEVEN_DAYS:'7 days',THIRTY_DAYS:'30 days',GREATER_THAN_30_DAYS:'> 30 days'
  }
export const TASK_HQ_STORAGE_KEYS ={
  IS_INCLUDE_CANCELED_TASKS: "is-include-canceled-tasks-in-task-hq-key",
  CANCELED_TASKS_MONTH_RANGE: "canceled-tasks-month-range-in-task-hq-key",
  IS_INCLUDE_COMPLETED_TASKS: "is-include-completed-tasks-in-task-hq-key",
  COMPLETED_TAKS_MONTH_RANGE: "completed-tasks-month-range-in-task-hq-key",
  IS_ACTIVE_TASK_TAB_IN_LIST_VIEW_MODE:
    "is-active-tasks-tab-in-list-view-mode-in-task-hq-key",
}
export const getMytasksDataFromLocalStorageOrDefault = () => {
  const tasksData = {
    isIncludeCanceledTasks: getLocalStorageValueOrDefault(
      TASK_HQ_STORAGE_KEYS.IS_INCLUDE_CANCELED_TASKS,
      defaultCompletedAndCanceledTabData.isIncludeCanceledTasks
    ),
    canceledTaskMonthRange: getLocalStorageValueOrDefault(
      TASK_HQ_STORAGE_KEYS.CANCELED_TASKS_MONTH_RANGE,
      defaultCompletedAndCanceledTabData.canceledTaskMonthRange
    ),
    isIncludeCompletedTasks: getLocalStorageValueOrDefault(
      TASK_HQ_STORAGE_KEYS.IS_INCLUDE_COMPLETED_TASKS,
      defaultCompletedAndCanceledTabData.isIncludeCompletedTasks
    ),
    completedTaskMonthRange: getLocalStorageValueOrDefault(
      TASK_HQ_STORAGE_KEYS.COMPLETED_TAKS_MONTH_RANGE,
      defaultCompletedAndCanceledTabData.completedTaskMonthRange
    ),
  };
  return tasksData;
};
const USER_TASK_SHOW_CHART_KEY = "userTaskChartButton";
const UserTaskChart: React.FC<any> = (props) => {
  const dispatch = useDispatch();
    const [isChartVisible, setIsChartVisible] = useState(true);
    const userTaskChartSelectedIndex = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskChartSelectedIndex,
    isEqual
    );
    var userTaskChartDataSource = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskChartDataSource,
    isEqual
    );
  const userTaskChartButton = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskChartButton,
    isEqual
);
const userTaskChartIcon = useSelector(
  (state: any) => state["userTaskListReducer"].userTaskChartIcon,
  isEqual
);
const currentUserId: any = useSelector(
  (state) => state["userTaskListReducer"].currentUserId,
  isEqual
  );
useEffect(() => {
  changeSelectedIndex();
}, [userTaskChartSelectedIndex, currentUserId]);

const changeSelectedIndex = () => {
  setIsGridSettingCalled(dispatch, false);
};

useEffect(() => {
  getUserPreference(USER_TASK_SHOW_CHART_KEY).then(({ settings }) => {
    if (settings) {
      dispatch({
        type: SET_USER_TASK_CHART_BUTTON_VALUE,
        data: { userTaskChartButton: settings },
      });
      toggleChart(settings === "Show Charts" ? "Hide Charts" : "Show Charts");
    }
  });
}, []);

useEffect(() => {
  dispatch({
    type: SET_TASK_HQ_COMPLETED_AND_CANCELED_TAB_DATA,
    data: {
      completedAndCanceledTabData: getMytasksDataFromLocalStorageOrDefault(),
    },
  });
});
const refreshGridAfterFilterChanges =(filter)=>{
  const instance = props?.dataGridInstance;

  if (instance) {
    instance.option('filterValue', null);
    instance.option('filterValue', filter);
    instance.refresh();
  }
} 
  const pieChartStatusDataSource = useMemo(() => {
    if (userTaskChartDataSource) {
      return [
        {
          status: USER_TASK_STATUS_TYPE.NEW,
          taskCount: userTaskChartDataSource.totalTasksNew,
        },
        {
          status: USER_TASK_STATUS_TYPE.IN_PROGRESS,
          taskCount: userTaskChartDataSource.totalTasksInProgress,
        },
      ];
    }
    return [];
  }, [userTaskChartDataSource,userTaskChartSelectedIndex]);

    const barChartTasksRemaining = useMemo(() => {
      if (userTaskChartDataSource) {
        return [
          {
            days: DAYS_RANGE.SEVEN_DAYS,
            taskCount: userTaskChartDataSource.totalTaskDueInSevenDays,
          },
          {
            days: DAYS_RANGE.THIRTY_DAYS,
            taskCount: userTaskChartDataSource.totalTasksDueInSevenToThirtyDays,
          },
          {
            days: DAYS_RANGE.GREATER_THAN_30_DAYS,
            taskCount:userTaskChartDataSource.totalTasksDueGreaterThanThirtyDays,
          },
        ];
      }
    else return [];
    }, [userTaskChartDataSource,userTaskChartSelectedIndex]);

    const barChartMostTaskAssigned =useMemo(() => {
      if(userTaskChartDataSource){
        const dataSource = [
          {
            name:  userTaskChartDataSource.mostAssignedTaskType ==='Multiple' ?'Multiple' : userTaskChartDataSource.userWithMostAssignedTasks?userTaskChartDataSource.userWithMostAssignedTasks:"",
            tasksCount: userTaskChartDataSource.countOfMostAssignedTasks || 0,
            displayUserNameString: userTaskChartDataSource.userWithMostAssignedTasks || '',
            displayUserName: userTaskChartDataSource.userWithMostAssignedTasks || '',
            displayUserNameRaw: userTaskChartDataSource.userWithMostAssignedTasksRaw || '',
          },
          {
            name:  userTaskChartDataSource.secondMostAssignedTaskType ==='Multiple' ?'Multiple' :userTaskChartDataSource.userWithSecondMostAssignedTasks?userTaskChartDataSource.userWithSecondMostAssignedTasks:"",
            tasksCount: userTaskChartDataSource.countOfSecondMostAssignedTasks || 0,
            displayUserNameString: userTaskChartDataSource.userWithSecondMostAssignedTasks || '',
            displayUserName: userTaskChartDataSource.userWithSecondMostAssignedTasks || '',
            displayUserNameRaw: userTaskChartDataSource.userWithSecondMostAssignedTasksRaw || '',
          },
          {
            name: userTaskChartDataSource.thirdMostAssignedTaskType ==='Multiple' ?'Multiple' : userTaskChartDataSource.userWithThirdMostAssignedTasks ?userTaskChartDataSource.userWithThirdMostAssignedTasks :"",
            tasksCount: userTaskChartDataSource.countOfThirdMostAssignedTasks || 0,
            displayUserNameString: userTaskChartDataSource.userWithThirdMostAssignedTasks || '',
            displayUserName: userTaskChartDataSource.userWithThirdMostAssignedTasks || '',
            displayUserNameRaw: userTaskChartDataSource.userWithThirdMostAssignedTasksRaw || '',
          }
        ];
        return dataSource;
      }else{return []

      }
    }, [userTaskChartDataSource,userTaskChartSelectedIndex]);
    
    const mostAssignTaskTooltip=(pointInfo)=> {
      return {
        text: `${pointInfo.point.data.displayUserNameString}<br/>`
      };
    }
    const pieChartStatusOnClick=(e)=>{
      const userTaskListDataGridFilter= [['statusType','=',e.target.data.status]];
        refreshGridAfterFilterChanges(userTaskListDataGridFilter);
    }
    const getDateOnly = (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate()); 
    };
    
    const barChartTasksRemainingOnClick = (e) => {
      let filter = null;
    
      switch (e.target.argument) {
        case DAYS_RANGE.SEVEN_DAYS:
          filter = [['dueDate', 'between',[getDateOnly(new Date()), getDateOnly(getFutureDateFromDays(7))]], "and", [['statusType', '=', USER_TASK_STATUS_TYPE.IN_PROGRESS],'or', ['statusType', '=',USER_TASK_STATUS_TYPE.NEW] ]]
          break;
    
        case DAYS_RANGE.THIRTY_DAYS:
          filter = [['dueDate', 'between',[getDateOnly(getFutureDateFromDays(7)), getDateOnly(getFutureDateFromDays(30))]], "and", [['statusType', '=', USER_TASK_STATUS_TYPE.IN_PROGRESS],'or', ['statusType', '=',USER_TASK_STATUS_TYPE.NEW] ]]
          break;
    
        case DAYS_RANGE.GREATER_THAN_30_DAYS:
          filter = [['dueDate', '>=', getDateOnly(getFutureDateFromDays(30))], "and", [['statusType', '=', USER_TASK_STATUS_TYPE.IN_PROGRESS],'or', ['statusType', '=',USER_TASK_STATUS_TYPE.NEW] ]]
          break;
    
        default:
          return;
      }
    
      refreshGridAfterFilterChanges(filter);
    };
    const refreshCompletedAndCanceledTask = useCallback(() => {
      const instance = props?.dataGridInstance;
      if (instance) {
        instance.refresh();
      }
    }, [props?.dataGridInstance]);
    
    const barChartMostTaskAssignedOnClick = (e) => {
      if (!props?.dataGridInstance || !e?.target?.data?.displayUserNameRaw) return;
      const usersRaw = e?.target?.data?.displayUserNameRaw || '';
      const userArray = usersRaw.split(';').map(u => u.trim()).filter(Boolean);
      
      const filter = [
        ['assignedToUserName', 'anyof', userArray],
        'and',
        [['statusType', '=', USER_TASK_STATUS_TYPE.IN_PROGRESS],'or', ['statusType', '=',USER_TASK_STATUS_TYPE.NEW] ],
          
      ];
      refreshGridAfterFilterChanges(filter); 
    };
    const completedTaskUpdaterConfig = useMemo(() => [
      {
        actionType: SET_TASK_HQ_COMPLETED_AND_CANCELED_TAB_DATA,
        reducerName: "userTaskListReducer",
        widgetOptionBindings: {
          value: "completedAndCanceledTabData.isIncludeCompletedTasks",
        },
      },
    ], []);
    const completedTaskMonthUpdaterConfig = useMemo(() => [
      {
        actionType: SET_TASK_HQ_COMPLETED_AND_CANCELED_TAB_DATA,
        reducerName: "userTaskListReducer",
        widgetOptionBindings: {
          value: "completedAndCanceledTabData.completedTaskMonthRange",
        },
      },
    ], []);
    const canceledTaskUpdaterConfig = useMemo(() => [
      {
        actionType: SET_TASK_HQ_COMPLETED_AND_CANCELED_TAB_DATA,
        reducerName: "userTaskListReducer",
        widgetOptionBindings: {
          value: "completedAndCanceledTabData.isIncludeCanceledTasks",
        },
      },
    ], []);
    const canceledTaskMonthUpdaterConfig = useMemo(() => [
      {
        actionType: SET_TASK_HQ_COMPLETED_AND_CANCELED_TAB_DATA,
        reducerName: "userTaskListReducer",
        widgetOptionBindings: {
          value: "completedAndCanceledTabData.canceledTaskMonthRange",
        },
      },
    ], []);
    const taskChartComponent = useMemo(() => {
      return (
        <div className="user-task-charts">
          {userTaskChartSelectedIndex == 0  && isChartVisible && (
            <div id="userTasksCharts"className="task-chart-border task-chart-flex-container task-charts">
              <div className="float-child">
                <MdaePieChart
                  id="userTaskStatusPie"
                  palette="Bright"
                  title={"Tasks by Status"}
                  diameter={0.5}
                  dataSource={pieChartStatusDataSource}
                  onPointClick={pieChartStatusOnClick}
                >
                  <Series argumentField="status" valueField="taskCount" />
                  <Size height={340} width={255} />
                </MdaePieChart>
              </div>
    
              <div className="float-child">
                <MdaeChart
                  id="barChartTimeRemaining"
                  palette="Bright"
                  dataSource={barChartTasksRemaining}
                  onPointClick={barChartTasksRemainingOnClick}
                  maxBubbleSize={0.05}
                >
                  <Size height={280} width={255} />
                  <Legend visible={false} />
                  <CommonSeriesSettings
                    argumentField="days"
                    valueField="taskCount"
                    type="bar"
                    ignoreEmptyPoints={true}
                  />
                  <SeriesTemplate nameField="days" />
                  <Title
                    text={ "Time Remaining"}
                    horizontalAlignment="center"
                  />
                </MdaeChart>
              </div>
    
              <div className="float-child">
                <MdaeChart
                  id="barChartMostTaskAssigned"
                  palette="Bright"
                  dataSource={barChartMostTaskAssigned}
                  onPointClick={barChartMostTaskAssignedOnClick}
                  maxBubbleSize={0.05}
                >
                  <Tooltip enabled={true} customizeTooltip={mostAssignTaskTooltip} />
                  <Size height={280} width={255} />
                  <Legend visible={false} />
                  <CommonSeriesSettings
                    argumentField="name"
                    valueField="tasksCount"
                    type="bar"
                    ignoreEmptyPoints={true}
                  />
                  <SeriesTemplate nameField="name" />
                  <Title
                    text="Most Tasks Assigned"
                    horizontalAlignment="center"
                  />
                </MdaeChart>
              </div>
            </div>
          )} 
          {userTaskChartSelectedIndex == 1 && (
            <div className="task-chart-border task-chart-flex-container month-range">
              <TaskFilter
                refreshCompletedAndCanceledTask={refreshCompletedAndCanceledTask}
                STORAGE_KEYS={TASK_HQ_STORAGE_KEYS}
                completedTaskUpdaterConfig={completedTaskUpdaterConfig}
                completedTaskMonthUpdaterConfig={completedTaskMonthUpdaterConfig}
                canceledTaskUpdaterConfig={canceledTaskUpdaterConfig}
                canceledTaskMonthUpdaterConfig={canceledTaskMonthUpdaterConfig}
                isShowSearchBar={false}
              />
            </div>
          )}
        </div>
      );
    }, [userTaskChartDataSource, userTaskChartSelectedIndex,isChartVisible]);
   const taskChartComponents =()=>{
    return taskChartComponent;
  }
  const toggleChart = useCallback((data) => {
   const  value = data ==="Show Charts" ?true:false;
    setIsChartVisible(value);
  
    let textValue, icon;
    if (value) {
      textValue = "Hide Charts";
      icon = "fas fa-caret-down";
    } else {
      textValue = "Show Charts";
      icon = "fas fa-caret-right";
    }
  
    setUserPreference(USER_TASK_SHOW_CHART_KEY, textValue);
    dispatch({ type: SET_USER_TASK_CHART_BUTTON_VALUE, data: { userTaskChartButton: textValue } });
    dispatch({ type: SET_USER_TASK_CHART_ICON_VALUE, data: { userTaskChartIcon: icon } });
  }, [isChartVisible]);
    
      return( <div>
        {userTaskChartSelectedIndex == 0 && (
          <div className="start-new-line user-task-chart-margin">
            <MdaeButton
              id="btnShowCharts"
              role="dxButton"
              stylingMode={"text"}
              text={userTaskChartButton}
              icon={userTaskChartIcon}
              onClick={(e) => toggleChart(e.component.option("text"))}
              style={{ border: "unset" }}
            />
          </div>  
        )}
      <div  className="user-task-chart-margin">
      <div className="start-new-line chart-tabs" style={{margin:"0px 0px 0px 15px"}}>
      <MdaeButton id="btnTasksInFlight" role="dxButton" onClick={()=>{
        dispatch({
          type:SET_USER_TASK_CHART_SELECTED_INDEX,
          data:{userTaskChartSelectedIndex:0}
      })}
      }
      className={(() =>
        userTaskChartSelectedIndex == 0
          ? "remove-button-styles dx-item dx-tab dx-tab-selected"
          : "remove-button-styles dx-item dx-tab")()}>Active Tasks</MdaeButton>

      <MdaeButton id="btnTasksPastDue" role="dxButton" onClick={()=>{
        dispatch({
          type:SET_USER_TASK_CHART_SELECTED_INDEX,
          data:{userTaskChartSelectedIndex:1}
      })}
      }
      className={(() =>
        userTaskChartSelectedIndex == 1
          ? "remove-button-styles dx-item dx-tab dx-tab-selected"
          : "remove-button-styles dx-item dx-tab")()}>Completed & Canceled Tasks</MdaeButton>
    </div>
      {taskChartComponents()} </div>
      </div>)
   
}
export default UserTaskChart;
